import React, { useState } from 'react';

const Impressum = () => { 

    return (
        <div>
                <div className="impressum-content">
                    <h2>Impressum</h2>
                    <h4>Angaben gemäß § 5 TMG:</h4>
                    <p>Joelina M. Haseloh <br />
                    Dreikönigenstr. 37 <br />
                    50997 Köln</p>

                    <h4>Kontakt: </h4>
                    <p>E-Mail: joe.haseloh@gmail.com</p>
                    <p>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV ist Joelina M. Haseloh</p>

                    <h4>Haftungsausschluss: </h4>
                    <p>Die Inhalte meiner Seite wurden mit größter Sorgfalt erstellt. Dennoch übernehmen wir keine Haftung für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte. Für externe Links übernehmen wir keine Haftung.</p>

                    <h4>Urheberrecht:</h4>
                    <p>Die Inhalte auf dieser Website sind urheberrechtlich geschützt.</p>
                    <h5>Portfolio Design Template von <a href="https://github.com/yujisatojr/react-portfolio-template" target="_blank" rel="noreferrer">Yuji Sato</a></h5>
                    <h5>Die Bildrechte für das Profilbild liegen bei <a href="https://www.ottobock.com" target="_blank" rel="noreferrer">Ottobock Deutschland</a>.</h5>

                    <h4>Datenschutz:</h4>


                    <h5>1. Verantwortlicher</h5>

                    <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist: Joelina M. Haseloh Dreikönigenstr. 37, 50997 Köln, Deutschland</p>
                    <p>E-Mail: joe.haseloh@gmail.com</p>

                    <h5>2. Erhebung und Verarbeitung von Daten</h5>

                    <p>Wir erheben keine personenbezogenen Daten von Besuchern dieser Website. Es werden keine Daten wie Name, Adresse, E-Mail-Adresse oder ähnliche Informationen gesammelt.</p>

                    <h5>3. Cookies</h5>

                    <p>Unsere Website verwendet keine Cookies zur Datensammlung. Falls Cookies verwendet werden, um die Nutzererfahrung zu verbessern (z.B. durch Drittanbieter wie Google Analytics), informieren wir Sie hierüber.</p>

                    <h5>4. Externe Dienste und Inhalte</h5>

                    <p>Auf dieser Website können Inhalte oder Dienste von externen Anbietern eingebunden sein (z.B. Videos, Karten), die dazu führen können, dass Daten an die Anbieter dieser Dienste übermittelt werden. Wir haben jedoch keinen Einfluss auf die Datenverarbeitung dieser Anbieter.</p>

                    <h5>5. Ihre Rechte</h5>

                    <p>Da keine personenbezogenen Daten verarbeitet werden, haben Sie in Bezug auf personenbezogene Daten keine spezifischen Rechte, wie das Recht auf Auskunft, Berichtigung oder Löschung.</p>

                    <h5>6. Datensicherheit</h5>

                    <p>Wir setzen angemessene technische und organisatorische Maßnahmen ein, um die Sicherheit der Website zu gewährleisten, aber wir erheben keine personenbezogenen Daten.</p>

                    <h5>7. Änderungen dieser Datenschutzerklärung</h5>

                    <p>Wir behalten uns vor, diese Datenschutzerklärung jederzeit zu ändern, um sie an gesetzliche Vorgaben oder neue technische Entwicklungen anzupassen.</p>
                    <br />
                    <p><i>Stand: November 2025</i></p>
                    <br />
                </div>
        </div>
    );
};

export default Impressum;